import React, { useEffect, useState } from "react";
import { Form, Button, Col, Row, Modal } from "react-bootstrap";
import Title from "../../../components/Admin/Title";
import useIsAdmin from "../../../hooks/useIsAdmin";
import ErrorPage from "../../ErrorPage";
import { useUser } from "../../../components/UserContext";
import axios from "axios";
import Select from "react-select";
import { toast } from "react-toastify";
import { getDriverNameLink } from "../../../utils/Standings";
import { Link } from "react-router-dom";
import Flag from "../../../components/Flag";
import { useTranslation } from "react-i18next";

const EditDiscordMessage = () => {
  const { t } = useTranslation();
  const { access } = useIsAdmin();
  document.title = "LVF1 - Edit Discord Message";
  const token = window.localStorage.getItem("userLogged");
  const { user } = useUser() as any;

  const toggleReplayDone = () => {
    if (token == null) return;
    const url = `${
      process.env.NODE_ENV === "development"
        ? "http://localhost:5500"
        : "https://ligavirtualf1.es:5500"
    }/api/admin/updateMessageDiscord`;
    axios
      .post(url, {
        user,
        token: JSON.parse(token).token,
      })
      .then((response) => {
        toast.success("Replays marked as done succesfully");
      })
      .catch((error) => {
        console.error("Error al descargar ZIP:", error.response || error);
      });
  };

  if (!access) return <ErrorPage />;

  return (
    <div className="full-height padding-md app-container flex-center-top page-transition">
      <div className="form-container-md overflowed">
        <Title text="Edit Discord Message" />

        {/* BOTÓN */}
        <Button variant="primary" onClick={() => toggleReplayDone()}>
          Add Charge
        </Button>
      </div>
    </div>
  );
};

export default EditDiscordMessage;
